import React from 'react';
import Layout from '../components/Layout';
import Hero from '../components/Hero';
import ContentRow from '../components/ContentRow';
import { ContinueWatchingRow, CategoryPanels } from '../components/HomeSections';
import { useApp } from '../context/AppContext';
import { useCatalog } from '../context/CatalogContext';

export default function Home() {
  const { homeCfg } = useApp();
  const { pick } = useCatalog();
  const rows = homeCfg.rows.map((r) => ({ ...r, items: pick(...r.items) }));
  return (
    <Layout bottom={<CategoryPanels />}>
      <Hero slides={homeCfg.heroSlides} />
      {rows.map((r) => <ContentRow key={r.id} title={r.title} items={r.items} testId={`row-${r.id}`} />)}
      <ContinueWatchingRow />
    </Layout>
  );
}
